var map = {
	"./quizzes/form": 5,
	"./quizzes/form.jsx": 5,
	"./quizzes/option": 2,
	"./quizzes/option.jsx": 2,
	"./quizzes/question": 1,
	"./quizzes/question.jsx": 1
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8;